import '../styles/Loading.css'
function Loading(){
	return  <div className="lds-spinner loader"></div> 
}

export default Loading